module.exports = __webpack_public_path__ + "static/media/chess-clock.415803b1.svg";